/// <amd-module name="TFS/Security/Common/Members/Contracts" />
import { GraphMember } from "VSS/Platform/Contracts/Graph";
import { ITreeItem } from "VSSUI/Utilities/TreeItemProvider";

export interface ISecurityMembersData {
    totalIdentityCount: number;
    errorMessage: string;
    identities: ICustomGraphViewModel[];
    supportServicePrincipals: boolean;
}

export interface ICustomGraphViewModel extends GraphMember {
    parentKey: string;
    isAadGroup: boolean;
}

//#region Tree
export interface IMembersTreeItem extends ITreeItem<ICustomGraphViewModel> {}

export interface ISecurityMembersParentsBucketKey {
    [key: string]: IMembersTreeItem;
}
